import React from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import { STATUS_COLORS, Color } from './consts';
import { useStatusColorToken } from './hooks/useStatusColorToken';

type StatusColorIndicatorProps = StylableComponent<HTMLDivElement> & {
  statusColor?: Color;
};
/**
 * A StatusColorIndicator
 * docs.
 */
const StatusColorIndicator = React.forwardRef<
  HTMLDivElement,
  StatusColorIndicatorProps
>(({ style, statusColor = STATUS_COLORS.BLUE, ...rest }, ref) => {
  const theme = useTheme();
  const { colors, ...statusColorIndicatorTokens } = theme.tokens?.component
    ?.statusColorIndicator ?? { colors: {} };
  const backgroundColor = useStatusColorToken(statusColor);

  return (
    <div
      {...rest}
      ref={ref}
      css={[
        statusColorIndicatorTokens,
        {
          backgroundColor,
        },
        style,
      ]}
    />
  );
});

StatusColorIndicator.displayName = 'StatusColorIndicator';

StatusColorIndicator.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Status color */
  statusColor: PropTypes.oneOf(Object.values(STATUS_COLORS)),
};

export default Object.assign(StatusColorIndicator, { COLORS: STATUS_COLORS });
